import { useMutation } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { submitVenueBusinessInfoChangeRequest } from '@/lib/venue/venueBusinessInfoApi'
import type { VenueBusinessInfoChangeRequestInput, VenueBusinessInfoView } from '@/lib/venue/venueBusinessInfoTypes'

/**
 * M1 — 사업자 정보 수정 요청 접수(#1191, 백엔드 #1189 §D7).
 *
 * 🚨 성공 응답을 캐시에 반영하지 않는다 — 화면이 성공 시 로컬 상태로 "접수 완료" 안내를 그리고,
 * 현황 조회(`useVenueBusinessInfo`)는 재조회하지 않는다(`useSubmitOperationVerification`과 같은 관례,
 * Reader 복제 지연 회피).
 */
export function useSubmitVenueBusinessInfoChangeRequest(venueId: string) {
  return useMutation<VenueBusinessInfoView, ApiError, VenueBusinessInfoChangeRequestInput>({
    mutationFn: (input) => submitVenueBusinessInfoChangeRequest(venueId, input),
  })
}
